import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'src-modules-default-survey-thank-you-page-title' },
  subtitle: { id: 'src-modules-default-survey-thank-you-page-subtitle' },
  text: { id: 'src-modules-default-survey-thank-you-page-text' },
  cta: { id: 'src-modules-default-survey-thank-you-page-cta' },
  socials: { id: 'src-modules-default-survey-thank-you-page-socials' },
  hoverPELogo: { id: 'src-modules-default-survey-thank-you-page-hoverLogo' },
  copyLinkSuccess: { id: 'src-modules-default-survey-thank-you-page-copyLinkSuccess' },
  emailContent: { id: 'src-modules-default-survey-thank-you-page-email-content' },
  emailSubject: { id: 'src-modules-default-survey-thank-you-page-email-subject' },
  SEOtitle: {
    id: 'default-survey-thank-you-page-seoTitle',
    defaultMessage: 'Vielen Dank für Ihre Bewertung',
  },
  SEOdescription: {
    id: 'default-survey-thank-you-page-seoDescription',
    defaultMessage: 'Jetzt weiterempfehlen!',
  },
});

export default messages;
